import React from 'react'
import "./css/Upload.css";
import { useState, useEffect } from 'react';
import { auth, firestore, storage } from '../firebase';
import { ref, getDownloadURL, uploadBytes } from 'firebase/storage';
import { v4 as uuid } from 'uuid';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useStateValue } from './StateProvider'

function UploadProduct() {
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [delivery, setDelivery] = useState('');
  const [category, setCategory] = useState('');
  const [country, setCountry] = useState('');
  const [countryTo, setCountryTo] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);
  const [specifications, setSpecifications] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const history = useHistory();

  const [{basket, user}, dispatch] = useStateValue();

  const handleImage = (e) => {
    const selectedImages = Array.from(e.target.files);

    if (!selectedImages.every((image) => image.type.startsWith('image/'))) {
      alert('Please select only image files.');
      return;
    }

    setImages(selectedImages);
  };

  const openFileDialog = () => {
    const fileInput = document.getElementById('image-input');
    if (fileInput) {
      fileInput.click();
    }
  };

  const uploadJob = async (e) => {
    e.preventDefault();
  
    try {
      const imageUrls = [];
  
      for (const image of images) {
        const imageUuid = uuid();
        const imageRef = ref(storage, `product-pictures/${image.name}-${imageUuid}`);
        await uploadBytes(imageRef, image);
        const imageUrl = await getDownloadURL(imageRef);
        imageUrls.push(imageUrl);
      }
  
      const productInfo = {
        productImage: imageUrls,
        uid: auth?.currentUser?.uid,
        productName: name,
        productPrice: price,
        productDelivery: delivery,
        productCategory: category,
        productDesc: description,
        productCountry: country,
        productShipsTo: countryTo,
        specifications: specifications,
      };
  
      await firestore.collection('products').doc(name).set(productInfo);
  
      alert('Product Successfully Uploaded');
      window.location.reload();
      history.push('/');
    } catch (error) {
      console.error('Error uploading product:', error);
      alert('Failed to upload product');
    }
  };
  
  return (
    <div className='upload-product'>
        <div className='upload-product-info'>
            <h2>Upload a new product</h2>
            <p>Fill in the informations needed to upload your product</p>
        </div>

        <div className='upload-product-informations'>
          <form>
            <input type='text' maxLength={120}
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus={true}
              placeholder='Product Name' required />

            <input type='number'
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              autoFocus={true}
              placeholder='Product Price' required />

            <select style={{height: "5vh", marginBottom: "1%"}} value={category} onChange={(e) => setCategory(e.target.value)} autoFocus={true}>
            <option value="">Select Category</option>
            <option value="kids">Kids</option>
            <option value="workout">Workout</option>
            <option value="electrical">Electrical</option>
            <option value="home&accessories">Home&Accessories</option>
            </select>

            <input type="text" maxLength={60}
              value={delivery}
              onChange={(e) => setDelivery(e.target.value)}
              autoFocus={true}
              placeholder='Product Delivery Date' required />

              <input type="text" maxLength={60}
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              autoFocus={true}
              placeholder='Ships From' required />

              <input type="text" maxLength={60}
              value={countryTo}
              onChange={(e) => setCountryTo(e.target.value)}
              autoFocus={true}
              placeholder='Ships To' required />

            <textarea maxLength={600}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              autoFocus={true}
              placeholder='Product Description' required></textarea>

            <input
                  type="file"
                  id="image-input"
                  accept='image/gif, image/jpeg, image/jpg, image/png'
                  name="image"
                  onChange={handleImage}
                  style={{ display: 'none' }}
                  multiple
                />
            <p onClick={openFileDialog} style={{fontSize: "medium", fontWeight: "600",paddingTop: "7px", paddingBottom: "7px", paddingRight: "20px", paddingLeft: "20px", cursor: "pointer", fontFamily: "sans-serif",}}>Add Photos</p>

            {images.length > 0 && (
            <div className='image-box'>
              {images.map((image, index) => (
                <img key={index} src={URL.createObjectURL(image)} alt={`Image ${index + 1}`} />
              ))}
            </div>
          )}
            <button onClick={uploadJob}>Upload Product</button>
          </form>
        </div>
    </div>
  )
}

export default UploadProduct
